import deviceKitName from "./deviceKitName";
import deviceTypes from "./deviceTypes";

const deviceTypesConfig = {
  [deviceKitName.IQOS_24]: {
    [deviceTypes.DEV_TYPE_V24_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_V24_HOLDER]: ["HOLDER"]
  },
  [deviceKitName.IQOS_24P]: {
    [deviceTypes.DEV_TYPE_V24P_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_V24P_HOLDER]: ["HOLDER"]
  },
  [deviceKitName.IQOS_3]: {
    [deviceTypes.DEV_TYPE_P1V30_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_P1V30_HOLDER]: ["HOLDER"]
  },
  [deviceKitName.IQOS_3_DUO]: {
    [deviceTypes.DEV_TYPE_P1V31_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_P1V31_HOLDER]: ["HOLDER"]
  },
  [deviceKitName.IQOS_3_MULTI]: {
    [deviceTypes.DEV_TYPE_P1V30M]: ["MONO"]
  },
  [deviceKitName.IQOS_VEEV]: {
    [deviceTypes.DEV_TYPE_P4_M3_G1]: ["MONO"],
    [deviceTypes.DEV_TYPE_P4_M3_G2]: ["MONO"]
  },

  [deviceKitName.IQOS_ILUMA_ONE]: {
    [deviceTypes.DEV_TYPE_P1V40D_CONTROL]: ["DEVICE-CONTROL", "DEVICE-ENGINE"]
  },
  [deviceKitName.IQOS_ILUMA_PRIME]: {
    [deviceTypes.DEV_TYPE_P1V40V_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_P1V40V_HOLDER_CONTROL]: ["HOLDER-CONTROL", "HOLDER-ENGINE"]
  },
  [deviceKitName.IQOS_ILUMA]: {
    [deviceTypes.DEV_TYPE_P1V40C_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_P1V40C_HOLDER_CONTROL]: ["HOLDER-CONTROL", "HOLDER-ENGINE"]
  },
  [deviceKitName.IQOS_ORIGINALS_ONE]: {
    [deviceTypes.DEV_TYPE_P1V31M]: ["MONO"]
  },
  [deviceKitName.IQOS_ARIANE]: {
    [deviceTypes.DEV_TYPE_P1_ARIANE]: ["MONO"]
  },
  [deviceKitName.IQOS_ILUMA_I]: {
    [deviceTypes.DEV_TYPE_P1V41P_CHARGER]: ["CHARGER"],
    [deviceTypes.DEV_TYPE_P1V41_HOLDER_ENGINE]: ["HOLDER-ENGINE"],
    [deviceTypes.DEV_TYPE_P1V41_HOLDER_CONTROL]: ["HOLDER-CONTROL"]
  }
};

export default deviceTypesConfig;
